import { getEventList } from "@/apis";


export const EventDataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    let response;

    response = await getEventList(meta.type, meta.id, {current:pagination.current, pageSize:pagination.pageSize, filters, sorters});
    if (response.status === "error") {
      throw new Error(response.error);
    } else {
      let count = response.value.listMeta.totalItems;
      const data = [];
      if(response.value.events){
        let idx = 0;
        response.value.events.forEach((item) => {
          let evt = {type: item.type, name: item.objectMeta.name, message:item.message, reason:item.reason, count:item.count};
          evt.source = `${item.sourceHost} ${item.sourceComponent}`;
          evt.object = `${item.objectKind}/${item.objectNamespace}`;
          evt.firstSeen = item.firstSeen;
          evt.lastSeen = item.lastSeen;
          evt.key = idx++;
          data.push(evt);
        });
      }
      return {
          data,
          total: count||meta._total_,
      };
    }
  },  
};